import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { CHARGE_LABEL } from "@/lib/format";
import { Btn, Card, Field, PageTitle } from "@/components/admin/AdminUI";

const FIELDS = [
  { key: "name", label: "Nombre" }, { key: "image", label: "Foto", type: "media" },
  { key: "description", label: "Descripción", type: "textarea", wide: true },
  { key: "price", label: "Precio (CLP)", type: "number" },
  { key: "charge_mode", label: "Modalidad de cobro", type: "select", options: Object.entries(CHARGE_LABEL) },
  { key: "max_qty", label: "Cantidad máxima (por unidad)", type: "number" },
  { key: "resource", label: "Requiere disponibilidad de", type: "select", options: [["", "Nada"], ["tinaja", "Tinaja"], ["habitacion", "Habitación adicional"]] },
  { key: "adds_guests", label: "Agrega capacidad de huéspedes", type: "number" },
  { key: "order", label: "Orden", type: "number" },
  { key: "active", label: "Activo", type: "switch" },
];

function ExtraEditor({ x0, onDeleted }) {
  const [x, setX] = useState({ ...x0, resource: x0.resource || "" });
  const save = async () => { try { await api.put(`/admin/extras/${x.id}`, x); toast.success("Servicio guardado"); } catch (e) { toast.error(errMsg(e)); } };
  const del = async () => { if (!window.confirm(`¿Eliminar ${x.name}?`)) return; await api.delete(`/admin/extras/${x.id}`); onDeleted(); };
  return (
    <Card data-testid={`extra-editor-${x.id}`}>
      <div className="grid sm:grid-cols-2 gap-3">{FIELDS.map((f) => <Field key={f.key} f={f} value={x[f.key]} onChange={(v) => setX((p) => ({ ...p, [f.key]: v }))} testid={`extra-${x.id}-${f.key}`} />)}</div>
      <div className="mt-4 flex gap-2">
        <Btn onClick={save} data-testid={`save-extra-${x.id}`}>Guardar</Btn>
        <Btn variant="outline" onClick={del} data-testid={`delete-extra-${x.id}`}><Trash2 className="h-4 w-4" />Eliminar</Btn>
      </div>
    </Card>
  );
}

export default function AdminExtras() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/extras").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const create = async () => { await api.post("/admin/extras", { name: "Nuevo servicio" }); load(); toast.success("Servicio creado"); };
  return (
    <div data-testid="admin-extras-page">
      <PageTitle title="Extras · Personaliza tu experiencia">
        <Btn variant="accent" onClick={create} data-testid="create-extra-btn"><Plus className="h-4 w-4" />Nuevo servicio</Btn>
      </PageTitle>
      <p className="text-sm text-muted-foreground mb-6 -mt-4">Estos servicios se ofrecen exclusivamente en reservas de cabaña. Los que requieren tinaja o habitación validan disponibilidad cada noche.</p>
      <div className="grid xl:grid-cols-2 gap-6">{items.map((x) => <ExtraEditor key={x.id} x0={x} onDeleted={load} />)}</div>
    </div>
  );
}
